export default "__VITE_ASSET__BxHBMwQS__"